var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { NavigationSkipLinkContainer } from './styles/navigation-skip-link.styled';
/**
 * The skip link is a link that is used to skip to a specific part of the page.
 * It is used to skip to the main content of the page when the user first navigates with the keyboard.
 */
export const NavigationSkipLink = (_a) => {
    var { children, href, dataTest = 'navigation-skip-link' } = _a, props = __rest(_a, ["children", "href", "dataTest"]);
    const skipLinkRef = useRef();
    useEffect(() => {
        if (!skipLinkRef.current || !href) {
            return () => { };
        }
        const handleSkipLinkClick = () => {
            const target = document.querySelector(href);
            if (!target) {
                return;
            }
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            target.focus();
        };
        skipLinkRef.current.addEventListener('click', handleSkipLinkClick);
        return () => {
            var _a;
            (_a = skipLinkRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', handleSkipLinkClick);
        };
    }, [skipLinkRef]);
    return (_jsx(NavigationSkipLinkContainer, Object.assign({ href: href, inputRef: skipLinkRef, variant: "button-link", tagName: "a", "data-test": dataTest }, props, { children: children })));
};
